"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSBlockMoving = exports.TSDir = exports.TSBlock = exports.TSBlockAttribute = void 0;
const TSColors_1 = require("./TSColors");
const Z20Entity_1 = require("./Z20Entity");
const KHRandom_1 = require("./KH/KHRandom");
var TSBlockAttribute;
(function (TSBlockAttribute) {
    TSBlockAttribute[TSBlockAttribute["None"] = 0] = "None";
    TSBlockAttribute[TSBlockAttribute["Blocks"] = 1] = "Blocks";
    TSBlockAttribute[TSBlockAttribute["PushableSanitize"] = 2] = "PushableSanitize";
    TSBlockAttribute[TSBlockAttribute["ChaseAndKill"] = 3] = "ChaseAndKill";
    TSBlockAttribute[TSBlockAttribute["Icy"] = 4] = "Icy";
})(TSBlockAttribute || (exports.TSBlockAttribute = TSBlockAttribute = {}));
class TSBlock extends Phaser.GameObjects.Container {
    constructor(scene, type, attr = TSBlockAttribute.Blocks, fns = [], spriteOverride) {
        super(scene, 0, 0);
        this._dead = false;
        scene.add.existing(this);
        this.attr = attr;
        this.fns = fns;
        if (spriteOverride) {
            this.animLoad(scene, spriteOverride);
        }
        else if (type === TSColors_1.TSBlockType.Tree) {
            this.standardLoad(scene, 'tree');
        }
        if (type instanceof Z20Entity_1.default) {
            if (type.animates)
                this.animLoad(scene, type.sprite);
            else
                this.standardLoad(scene, type.sprite);
            this.entity = type;
            type = TSColors_1.TSBlockType.Entity;
        }
        this.trophy = scene.add.sprite(0, -18, 'trophy');
        this.add(this.trophy);
        this.trophy.visible = false;
        this.add(this._block);
        this.setType(type);
    }
    setFrame(num) {
        this._block.setFrame(num);
    }
    standardLoad(scene, sprite) {
        this._block = scene.add.sprite(0, 0, sprite);
    }
    animLoad(scene, sprite) {
        this._block = scene.add.sprite(0, 0, sprite);
        this._block.play({ key: `${sprite}-idle`, repeat: -1 });
    }
    setFlipped(flipped) {
        this._block.flipX = flipped;
    }
    isDead() {
        return this._dead;
    }
    getType() {
        return this._type;
    }
    setType(type) {
        this._type = type;
    }
    addToGrid(grid, x, y) {
        this._grid = grid;
        this.moveToSlot(x, y);
    }
    moveToSlot(x, y) {
        this.pos = new Phaser.Math.Vector2(x, y);
        this._grid.forceAddAt(this, this.pos.x, this.pos.y);
    }
    animateIn(delay = 0) {
        const start = this.y - 32;
        const inPos = this.y;
        this.y = start;
        this.setVisible(false);
        this.scene.tweens.add({
            targets: this,
            y: inPos,
            delay: delay,
            onStart: () => this.setVisible(true),
            ease: 'Bounce.easeOut',
            duration: 750
        });
    }
    showTrophy(show) {
        this.trophy.visible = show;
    }
    runAway(delay, dir) {
        const rand = new KHRandom_1.KHRandomGeneral();
        const timePer = rand.nextFloat(30, 60);
        this.scene.tweens.add({
            targets: this,
            delay,
            x: this.x + dir.x * 300,
            y: this.y + dir.y * 300,
            duration: rand.nextFloat(500, 800),
            onComplete: () => {
                this.silentKill();
            }
        });
        // const event = this.scene.time.addEvent({
        //     repeat: 20,
        //     delay: timePer,
        //     callback: () => {
        //         if (event.repeatCount === 0) {
        //             this._grid.remove(this);
        //             this.destroy();
        //         }
        //     }
        // })
    }
    celebrate(delay = 0, killAfter = false) {
        this.scene.tweens.add({
            targets: this,
            angle: 360,
            ease: Phaser.Math.Easing.Back.InOut,
            duration: 1000,
            delay: delay,
            onComplete: () => {
                if (killAfter)
                    this.kill(200);
            }
        });
    }
    silentKill() {
        this._grid.remove(this);
        this.destroy();
    }
    kill(delay = 0) {
        if (this._dead) {
            console.warn("Attempted to double kill", this);
            return 300;
        }
        this._grid.remove(this);
        this._dead = true;
        const start = this.y;
        const inPos = this.y - 3;
        const outPos = this.y + 64;
        const timeline = this.scene.tweens.chain({
            targets: this,
            tweens: [{
                    y: inPos,
                    ease: 'Cubic.easeOut',
                    duration: 50,
                    delay: delay,
                }, {
                    y: start,
                    ease: 'Cubic.easeIn',
                    duration: 50,
                }, {
                    y: outPos,
                    ease: 'Linear',
                    duration: 200,
                    onComplete: () => {
                        this.destroy();
                    }
                }]
        });
        return 200 + 50 + 50;
    }
    destroy(fromScene) {
        this._block.destroy();
        super.destroy(fromScene);
    }
    static BlockFnDieIfItem(item) {
        return (fnArgs) => {
            if (fnArgs.iface.hasItem(item)) {
                fnArgs.iface.scheduleKill(fnArgs.block);
            }
        };
    }
    static BlockFnGiveItem(item) {
        return (fnArgs) => {
            fnArgs.iface.giveItem(item);
        };
    }
}
exports.TSBlock = TSBlock;
TSBlock.BlockFnWin = (fnArgs) => {
    fnArgs.iface.win();
};
TSBlock.BlockFnLose = (fnArgs) => {
    fnArgs.iface.lose();
};
var TSDir;
(function (TSDir) {
    TSDir[TSDir["Up"] = 0] = "Up";
    TSDir[TSDir["Left"] = 1] = "Left";
    TSDir[TSDir["Right"] = 2] = "Right";
    TSDir[TSDir["Down"] = 3] = "Down";
})(TSDir || (exports.TSDir = TSDir = {}));
class TSBlockMoving extends TSBlock {
    constructor(scene, type, path, attr = TSBlockAttribute.Blocks, swaps) {
        super(scene, type, attr);
        this.swaps = swaps;
        this.path = path;
    }
    static Looping(scene, type, attr = TSBlockAttribute.Blocks, swaps, dir, start, bounds) {
        const path = this.PathToEdge(start, dir, bounds, false);
        const remainder = this.PathToEdge(this.BoundaryPos(start, this.OppositeDir(dir), bounds), dir, this.ModifiedBounds(start, dir, bounds), false);
        remainder.pop();
        path.push(...remainder);
        return new TSBlockMoving(scene, type, path, attr, swaps);
    }
    static Bouncing(scene, type, attr = TSBlockAttribute.Blocks, swaps, dir, start, bounds) {
        const path = this.PathToEdge(start, dir, bounds, false);
        const oppDir = this.OppositeDir(dir);
        path.push(...this.PathToEdge(this.BoundaryPos(start, dir, bounds), oppDir, bounds, true));
        const remainder = this.PathToEdge(this.BoundaryPos(start, oppDir, bounds), dir, this.ModifiedBounds(start, dir, bounds), true);
        remainder.pop();
        path.push(...remainder);
        return new TSBlockMoving(scene, type, path, attr, swaps);
    }
    static BoundaryPos(start, dir, bounds) {
        if (dir == TSDir.Left)
            return [bounds[0][0], start[1]];
        if (dir == TSDir.Right)
            return [bounds[1][0], start[1]];
        if (dir == TSDir.Up)
            return [start[0], bounds[0][1]];
        if (dir == TSDir.Down)
            return [start[0], bounds[1][1]];
    }
    static ModifiedBounds(start, dir, bounds) {
        if (dir == TSDir.Left)
            return [[start[0], bounds[0][1]], [bounds[1][0], bounds[1][1]]];
        if (dir == TSDir.Right)
            return [[bounds[0][0], bounds[0][1]], [start[0], bounds[1][1]]];
        if (dir == TSDir.Up)
            return [[bounds[0][0], start[1]], [bounds[1][0], bounds[1][1]]];
        if (dir == TSDir.Down)
            return [[bounds[0][0], bounds[0][1]], [bounds[1][0], start[1]]];
    }
    static PathToEdge(start, dir, bounds, skipStart) {
        const path = [];
        let curr = start;
        const offset = this.OffsetForDir(dir);
        if (skipStart) {
            curr = [curr[0] + offset[0], curr[1] + offset[1]];
        }
        while (curr[0] >= bounds[0][0] && curr[0] <= bounds[1][0] && curr[1] >= bounds[0][1] && curr[1] <= bounds[1][1]) {
            path.push(curr);
            curr = [curr[0] + offset[0], curr[1] + offset[1]];
        }
        return path;
    }
    static OppositeDir(dir) {
        switch (dir) {
            case TSDir.Left: return TSDir.Right;
            default:
            case TSDir.Right: return TSDir.Left;
            case TSDir.Up: return TSDir.Down;
            case TSDir.Down: return TSDir.Up;
        }
    }
    static OffsetForDir(dir) {
        switch (dir) {
            case TSDir.Left:
                return [-1, 0];
            case TSDir.Right:
            default:
                return [1, 0];
            case TSDir.Up:
                return [0, -1];
            case TSDir.Down:
                return [0, 1];
        }
    }
    static ModifiedLocForBlock(block, dir) {
        return this.ModifiedLocForPos(block.pos, dir);
    }
    static ModifiedLocForPos(pos, dir) {
        return this.ModifiedLoc([pos.x, pos.y], dir);
    }
    static ModifiedLoc(pos, dir) {
        const offset = this.OffsetForDir(dir);
        return [pos[0] + offset[0], pos[1] + offset[1]];
    }
    static DirForOffset(offset) {
        if (offset[0] > 0)
            return TSDir.Right;
        if (offset[0] < 0)
            return TSDir.Left;
        if (offset[1] > 0)
            return TSDir.Down;
        if (offset[1] < 0)
            return TSDir.Up;
        return null;
    }
}
exports.TSBlockMoving = TSBlockMoving;
